import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import { companyInfo } from '../data/mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-atob-blue text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_a2b-facility/artifacts/4frauqel_AtoBObjektservice.png" 
              alt="AtoB Objektservice Logo" 
              className="h-16 md:h-20 w-auto object-contain mb-4"
            />
            <p className="text-gray-300 mb-4">
              Ihre Berater rund um Immobilien – mit einem geprüften Netzwerk aus Handwerk,
              Banken, Verwaltung und Recht.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-atob-orange/20 hover:bg-atob-orange rounded-full flex items-center justify-center transition-colors duration-200">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-atob-orange/20 hover:bg-atob-orange rounded-full flex items-center justify-center transition-colors duration-200">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-atob-orange/20 hover:bg-atob-orange rounded-full flex items-center justify-center transition-colors duration-200">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Schnellzugriff</h3>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  Leistungen
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('netzwerk')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  Netzwerk
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  Über uns
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('referenzen')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  Referenzen
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('faq')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  FAQ
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-300 hover:text-atob-orange transition-colors duration-200"
                >
                  Kontakt
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold mb-4">Unsere Leistungen</h3>
            <ul className="space-y-2 text-gray-300">
              <li>Kauf & Verkauf</li>
              <li>Finanzierung</li>
              <li>Sanierung & Handwerk</li>
              <li>Facility & Instandhaltung</li>
              <li>Portfolio-Beratung</li>
              <li>Erstberatung (kostenlos)</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Kontakt</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-atob-orange flex-shrink-0 mt-1" />
                <div>
                  <p>{companyInfo.address.street}</p>
                  <p>{companyInfo.address.city}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="h-5 w-5 text-atob-orange flex-shrink-0 mt-1" />
                <div>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-0.5">Büro (Festnetz)</p>
                  <a href={`tel:${companyInfo.phone_office.replace(/\s/g, '')}`} className="hover:text-atob-orange transition-colors block">{companyInfo.phone_office}</a>
                  <p className="text-xs text-gray-400 uppercase tracking-wider mt-2 mb-0.5">Mobil</p>
                  <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="hover:text-atob-orange transition-colors block">{companyInfo.phone}</a>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="h-5 w-5 text-atob-orange flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="hover:text-atob-orange transition-colors break-words">{companyInfo.email}</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} {companyInfo.name}. Alle Rechte vorbehalten.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="/impressum" target="_blank" className="text-gray-400 hover:text-atob-orange transition-colors duration-200">
                Impressum
              </a>
              <a href="/datenschutz" target="_blank" className="text-gray-400 hover:text-atob-orange transition-colors duration-200">
                Datenschutz
              </a>
              <a href="#" className="text-gray-400 hover:text-atob-orange transition-colors duration-200">
                AGB
              </a>
            </div>
          </div>
          <p className="text-gray-500 text-xs mt-4 text-center">
            Geschäftsführer: {companyInfo.managing_director}
          </p>
        </div>
      </div>
    </footer>
  );
};
